<template>
  <div class="back">
    <div id="playerOne"></div>
  </div>
</template>

<script>
import polyvPlayer from 'polyvPlayer';
import queryString from 'query-string';
export default {
  name: 'VideoPlayerLand',
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const { videoId } = searchParams;

    polyvPlayer({
      wrap: '#playerOne',
      width: (window.innerHeight * 854) / 480,
      height: window.innerHeight,
      vid: videoId,
      forceH5: true,
      full_page_screen: false,
      allowFullscreen: false,
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.back {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
}

#playerOne {
  background-color: black;
}
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
